import { render, staticRenderFns } from "./withdrawal.vue?vue&type=template&id=276ddf59&scoped=true&"
import script from "./withdrawal.vue?vue&type=script&lang=js&"
export * from "./withdrawal.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal.vue?vue&type=style&index=0&id=276ddf59&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276ddf59",
  null
  
)

export default component.exports